import React, { useState, useRef, useEffect, useCallback } from "react";
import Header from "../components/Header";

const C = {
  primary:      "#5E0E73",
  primaryLight: "#6E1A85",
  primaryDeep:  "#3A0847",
  gold:         "#C9A84C",
  goldLight:    "#E8D5A0",
  goldBright:   "#F5D87A",
  dark:         "#1A0030",
  dark2:        "#120020",
};

const TESTIMONIALS = [
  {
    src:   "https://res.cloudinary.com/dt3jzl980/video/upload/v1779225770/%EF%B8%8F_%EF%B8%8F_%EF%B8%8F_%EF%B8%8F_%EF%B8%8FAmazing_Experience_at_Carnival_Castle_Carnival_Castle_is_truly_an_outstanding_place_fo_c9kccn.mp4",
    name:  "Aisha & Rahul",
    event: "Anniversary Night",
    loc:   "Banjara Hills",
    rating: 5,
  },
  {
    src:   "https://res.cloudinary.com/dt3jzl980/video/upload/v1779226083/Celebrations_turn_magical_at_Carnival_Castle_Kondapur_From_vibrant_ambience_to_mouth-waterin_n2kzca.mp4",
    name:  "Karan Mehta",
    event: "Birthday Surprise",
    loc:   "Jubilee Hills",
    rating: 5,
  },
  {
    src:   "https://res.cloudinary.com/dt3jzl980/video/upload/v1779226095/A_proud_parent_celebrated_their_daughter_s_1st_birthday_at_Carnival_Castle_and_shared_Your_fsomov.mp4",
    name:  "Rohit & Priya",
    event: "Love Proposal",
    loc:   "Kondapur",
    rating: 5,
  },
  {
    src:   "https://res.cloudinary.com/dt3jzl980/video/upload/v1779225770/%EF%B8%8F_%EF%B8%8F_%EF%B8%8F_%EF%B8%8F_%EF%B8%8FAmazing_Experience_at_Carnival_Castle_Carnival_Castle_is_truly_an_outstanding_place_fo_c9kccn.mp4",
    name:  "Sruthi Varma",
    event: "Bride To Be",
    loc:   "Madhapur",
    rating: 5,
  },
  {
    src:   "https://res.cloudinary.com/dt3jzl980/video/upload/v1779226107/A_truly_magical_celebration_at_Carnival_Castle_From_the_fog_entrance_effect_to_the_beautiful_nbcvka.mp4",
    name:  "Divya Nair",
    event: "Mom To Be",
    loc:   "Gachibowli",
    rating: 5,
  },
];

export default function VideoTestimonialsPage() {
  const [activeIdx,     setActiveIdx]     = useState(0);
  const [playing,       setPlaying]       = useState(false);
  const [progress,      setProgress]      = useState(0);
  const [transitioning, setTransitioning] = useState(false);

  const videoRef   = useRef(null);
  const sectionRef = useRef(null);
  const autoRef    = useRef(null);

  const cur = TESTIMONIALS[activeIdx];

  /* stop when scrolled out of view */
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          videoRef.current?.pause();
          setPlaying(false);
        }
      },
      { threshold: 0.25 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  /* reset on index change */
  useEffect(() => {
    const vid = videoRef.current;
    if (!vid) return;
    vid.pause();
    vid.currentTime = 0;
    vid.muted = false;
    setPlaying(false);
    setProgress(0);
  }, [activeIdx]);

  /* progress + ended */
  useEffect(() => {
    const vid = videoRef.current;
    if (!vid) return;
    const onTime = () => { if (vid.duration) setProgress((vid.currentTime / vid.duration) * 100); };
    const onEnd  = () => { setPlaying(false); setProgress(0); };
    vid.addEventListener("timeupdate", onTime);
    vid.addEventListener("ended",     onEnd);
    return () => {
      vid.removeEventListener("timeupdate", onTime);
      vid.removeEventListener("ended",     onEnd);
    };
  }, [activeIdx]);

  const isTouchDevice = () => window.matchMedia("(hover:none) and (pointer:coarse)").matches;

  const togglePlay = () => {
    const vid = videoRef.current;
    if (!vid) return;
    if (playing) {
      vid.pause();
      vid.muted = false;
      setPlaying(false);
    } else {
      vid.muted = false;
      vid.play().then(() => setPlaying(true)).catch(() => {});
    }
  };

  const handleMouseEnter = () => {
    if (isTouchDevice()) return;
    const vid = videoRef.current;
    if (vid && !playing) {
      vid.muted = false;
      vid.play().then(() => setPlaying(true)).catch(() => {});
    }
  };
  const handleMouseLeave = () => {
    if (isTouchDevice()) return;
    if (videoRef.current && playing) {
      videoRef.current.pause();
      setPlaying(false);
    }
  };

  const handleReelClick = () => togglePlay();

  const handlePlayBtnClick = (e) => {
    e.stopPropagation();
    togglePlay();
  };

  const goTo = useCallback((i) => {
    if (i === activeIdx || transitioning) return;
    setTransitioning(true);
    setTimeout(() => { setActiveIdx(i); setTransitioning(false); }, 300);
  }, [activeIdx, transitioning]);

  const goPrev = (e) => { e.stopPropagation(); goTo((activeIdx - 1 + TESTIMONIALS.length) % TESTIMONIALS.length); };
  const goNext = (e) => { e.stopPropagation(); goTo((activeIdx + 1) % TESTIMONIALS.length); };

  /* auto-advance only when not playing */
  useEffect(() => {
    if (!playing) {
      autoRef.current = setInterval(() => {
        setActiveIdx(i => (i + 1) % TESTIMONIALS.length);
      }, 5000);
    } else {
      clearInterval(autoRef.current);
    }
    return () => clearInterval(autoRef.current);
  }, [playing]);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;0,900;1,600;1,700&family=DM+Sans:wght@300;400;500;600;700&display=swap');

        @keyframes vts-goldBg  { 0%,100%{background-position:0% 50%} 50%{background-position:100% 50%} }
        @keyframes vts-shine   { 0%{left:-100%} 25%{left:130%} 100%{left:130%} }
        @keyframes vts-pulse   { 0%{transform:translate(-50%,-50%) scale(1);opacity:.45} 100%{transform:translate(-50%,-50%) scale(1.7);opacity:0} }
        @keyframes vts-nameIn  { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:translateY(0)} }
        @keyframes vts-eqBar   { 0%,100%{height:5px} 50%{height:18px} }
        @keyframes vts-ctrlIn  { from{opacity:0;transform:translateY(6px)} to{opacity:1;transform:translateY(0)} }

        .vts-sec {
          background: ${C.dark2};
          font-family: 'DM Sans', sans-serif;
          position: relative; overflow: hidden;
        }
        .vts-sec::before {
          content: ''; position: absolute; inset: 0;
          background:
            radial-gradient(ellipse 65% 50% at 20% 10%, rgba(94,14,115,.28) 0%, transparent 65%),
            radial-gradient(ellipse 50% 40% at 80% 90%, rgba(201,168,76,.08) 0%, transparent 65%);
          pointer-events: none; z-index: 0;
        }
        .vts-sec::after {
          content: ''; position: absolute; top: 0; left: 50%; transform: translateX(-50%);
          width: 180px; height: 2px;
          background: linear-gradient(90deg, transparent, ${C.gold}, transparent);
        }

        /* ── header ── */
        .vts-header {
          padding: 72px clamp(20px,5vw,60px) 52px;
          display: flex; align-items: flex-end;
          justify-content: space-between; flex-wrap: wrap; gap: 20px;
          position: relative; z-index: 2;
        }
        .vts-header::after {
          content: ''; position: absolute; bottom: 0;
          left: clamp(20px,5vw,60px); right: clamp(20px,5vw,60px);
          height: 1px;
          background: linear-gradient(90deg, transparent, rgba(201,168,76,.25), transparent);
        }
        .vts-eyebrow {
          display: flex; align-items: center; gap: 10px;
          font-size: 11px; font-weight: 700; letter-spacing: 3px;
          text-transform: uppercase; color: ${C.gold}; margin-bottom: 14px;
        }
        .vts-eyebrow-line { width: 26px; height: 1px; background: ${C.gold}; opacity: .55; }
        .vts-h {
          font-family: 'Playfair Display', serif;
          font-size: clamp(28px, 4vw, 46px);
          font-weight: 700; color: #fff; line-height: 1.1; margin: 0;
        }
        .vts-h em { font-style: italic; color: ${C.gold}; }
        .vts-counter {
          font-family: 'Playfair Display', serif;
          font-size: 14px; color: rgba(255,255,255,.3); flex-shrink: 0; align-self: flex-end;
        }
        .vts-counter span { color: #fff; font-size: 18px; font-weight: 700; }

        /* ── stage ── */
        .vts-stage {
          display: grid; grid-template-columns: 1fr 340px;
          min-height: 580px; position: relative; z-index: 1;
        }

        /* ── reel pane — arrows float left/right of the reel ── */
        .vts-reel-pane {
          position: relative;
          display: flex; align-items: center; justify-content: center;
          padding: 40px clamp(20px, 4vw, 50px);
          overflow: hidden;
          gap: 0;
        }

        /* side arrow buttons */
        .vts-side-arr {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 44px; height: 44px; border-radius: 50%;
          background: rgba(255,255,255,.08);
          border: 1px solid rgba(255,255,255,.18);
          color: rgba(255,255,255,.8);
          font-size: 22px; font-weight: 700;
          display: flex; align-items: center; justify-content: center;
          cursor: pointer; z-index: 10;
          transition: all .25s cubic-bezier(.25,1,.5,1);
          backdrop-filter: blur(10px);
          -webkit-tap-highlight-color: transparent;
          user-select: none;
          line-height: 1;
        }
        .vts-side-arr:hover {
          background: ${C.gold};
          color: ${C.dark};
          border-color: ${C.gold};
          box-shadow: 0 6px 24px rgba(201,168,76,.5);
          transform: translateY(-50%) scale(1.1);
        }
        .vts-side-arr:active {
          transform: translateY(-50%) scale(0.94);
        }
        /* position: sit just outside the reel edges with a comfortable gap */
        .vts-side-arr.prev { left: clamp(10px, 2vw, 30px); }
        .vts-side-arr.next { right: clamp(10px, 2vw, 30px); }

        /* ambient glow sphere */
        .vts-glow-sphere {
          position: absolute;
          width: 600px; height: 400px; border-radius: 50%;
          background: radial-gradient(circle, rgba(94,14,115,.22) 0%, transparent 70%);
          top: 50%; left: 50%; transform: translate(-50%, -50%);
          pointer-events: none; z-index: 0;
          transition: background .5s;
        }
        .vts-glow-sphere.playing-glow {
          background: radial-gradient(circle, rgba(201,168,76,.15) 0%, rgba(94,14,115,.2) 50%, transparent 70%);
        }

        /* reel container — 16:9 LANDSCAPE */
        .vts-reel {
          position: relative;
          width: 100%;
          max-width: 850px;
          aspect-ratio: 16 / 9;
          border-radius: 18px;
          overflow: hidden;
          background: #08020F; /* Dark background to fill letterboxing */
          border: 1px solid rgba(255,255,255,.08);
          box-shadow: 0 30px 80px rgba(0,0,0,.6);
          cursor: pointer;
          transition: border-color .35s, box-shadow .4s;
          z-index: 1;
          flex-shrink: 0;
          -webkit-tap-highlight-color: transparent;
          user-select: none;
        }
        .vts-reel:hover,
        .vts-reel.playing {
          border-color: rgba(201,168,76,.4);
          box-shadow:
            0 40px 100px rgba(0,0,0,.75),
            0 0 50px rgba(201,168,76,.1),
            0 0 0 1px rgba(255,255,255,.04);
        }

        /* notch — removed for landscape premium feel */
        .vts-notch {
          display: none;
        }

        /* progress bar */
        .vts-prog {
          position: absolute; top: 0; left: 0; right: 0;
          height: 4px; background: rgba(255,255,255,.08); z-index: 6;
        }
        .vts-prog-fill {
          height: 100%;
          background: linear-gradient(90deg, ${C.primary}, ${C.gold});
          border-radius: 0 2px 2px 0;
          transition: width .1s linear;
        }

        /* video — object-fit: contain ensures NO cropping of original video */
        .vts-video {
          position: absolute; inset: 0;
          width: 100%; height: 100%;
          object-fit: contain;
          display: block;
        }

        /* ── OVERLAY: slim bottom gradient only ── */
        .vts-ovl {
          position: absolute; inset: 0;
          background: linear-gradient(to top, rgba(10,0,20,.85) 0%, rgba(10,0,20,.2) 25%, transparent 50%);
          pointer-events: none; z-index: 2;
        }
        .vts-reel:not(.playing) .vts-ovl {
          background: linear-gradient(to top, rgba(10,0,20,.7) 0%, transparent 35%);
        }

        /* ── PLAY BUTTON & PULSE WRAPPER ── */
        .cc-play-button-wrapper {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 72px;
          height: 72px;
          z-index: 5;
        }

        .cc-play-pulse {
          position: absolute;
          left: 50%;
          top: 50%;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          border: 1.5px solid rgba(201,168,76,.5);
          transform: translate(-50%, -50%);
          pointer-events: none;
          animation: vts-pulse 2.5s ease-out infinite;
        }

        .cc-play-btn {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          background: rgba(10, 0, 20, 0.45);
          border: 1px solid rgba(201,168,76,.4);
          backdrop-filter: blur(8px);
          display: flex; align-items: center; justify-content: center;
          transition: all .3s cubic-bezier(.25,1,.5,1);
          box-shadow: 0 10px 40px rgba(0,0,0,.5);
          pointer-events: all;
          cursor: pointer;
        }
        .cc-play-btn:hover {
          background: rgba(201,168,76,.25);
          border-color: ${C.gold};
          box-shadow: 0 14px 44px rgba(201,168,76,.35);
          transform: scale(1.08);
        }
        .cc-play-btn svg { fill: #fff; transition: fill .2s; }
        .cc-play-btn:hover svg { fill: #fff; }

        @media(hover:none) and (pointer:coarse) {
          .cc-play-btn {
            background: rgba(10, 0, 20, 0.6);
          }
        }

        /* bottom info */
        .vts-reel-info {
          position: absolute; bottom: 0; left: 0; right: 0;
          padding: 18px 20px 22px; z-index: 4;
        }
        .vts-stars { display: flex; gap: 3px; margin-bottom: 12px; }
        .vts-identity {
          display: flex; align-items: center; gap: 12px;
          animation: vts-nameIn .4s cubic-bezier(.25,1,.5,1) .07s both;
        }
        .vts-avatar {
          width: 42px; height: 42px; border-radius: 50%;
          border: 2px solid rgba(201,168,76,.55);
          background: linear-gradient(135deg, ${C.primary}, ${C.primaryLight});
          display: flex; align-items: center; justify-content: center;
          font-family: 'Playfair Display', serif;
          font-size: 14px; font-weight: 700; color: ${C.goldLight};
          flex-shrink: 0;
        }
        .vts-name {
          font-family: 'Playfair Display', serif;
          font-size: 15px; font-weight: 700; color: #fff; margin-bottom: 0;
        }

        /* transition overlay */
        .vts-transition {
          position: absolute; inset: 0;
          background: ${C.dark2}; z-index: 10;
          opacity: 0; pointer-events: none; transition: opacity .28s;
        }
        .vts-transition.show { opacity: 1; pointer-events: all; }

        /* queue sidebar */
        .vts-queue {
          background: rgba(255,255,255,.025);
          border-left: 1px solid rgba(255,255,255,.06);
          display: flex; flex-direction: column; overflow: hidden;
        }
        .vts-queue-header {
          padding: 24px 24px 18px;
          border-bottom: 1px solid rgba(255,255,255,.06); flex-shrink: 0;
        }
        .vts-queue-title {
          font-size: 11px; font-weight: 700; letter-spacing: 2px;
          text-transform: uppercase; color: rgba(255,255,255,.3);
        }
        .vts-queue-list {
          flex: 1; overflow-y: auto; padding: 12px 0;
          scrollbar-width: thin; scrollbar-color: rgba(201,168,76,.2) transparent;
        }
        .vts-queue-list::-webkit-scrollbar { width: 4px; }
        .vts-queue-list::-webkit-scrollbar-thumb { background: rgba(201,168,76,.2); border-radius: 2px; }

        .vts-q-item {
          display: flex; align-items: center; gap: 14px;
          padding: 12px 20px; cursor: pointer; transition: all .25s;
          border-left: 3px solid transparent;
        }
        .vts-q-item:hover { background: rgba(255,255,255,.04); }
        .vts-q-item.active { background: rgba(201,168,76,.07); border-left-color: ${C.gold}; }

        .vts-q-thumb {
          width: 50px; height: 74px; border-radius: 10px; overflow: hidden;
          flex-shrink: 0; position: relative;
          border: 1px solid rgba(255,255,255,.07); transition: border-color .25s;
          display: flex; align-items: center; justify-content: center;
        }
        .vts-q-item.active .vts-q-thumb { border-color: rgba(201,168,76,.4); }
        .vts-q-thumb-bg {
          position: absolute; inset: 0;
          background: linear-gradient(155deg, ${C.primaryDeep} 0%, ${C.primary} 60%, rgba(201,168,76,.25) 100%);
        }
        .vts-q-initials {
          position: relative; z-index: 1;
          font-family: 'Playfair Display', serif;
          font-size: 13px; font-weight: 700; color: rgba(255,255,255,.75);
          transition: color .2s;
        }
        .vts-q-item.active .vts-q-initials { color: ${C.goldLight}; }

        .vts-q-eq-wrap {
          position: absolute; inset: 0;
          background: rgba(13,0,24,.65);
          display: flex; align-items: center; justify-content: center;
          border-radius: 9px; z-index: 2;
        }
        .vts-q-eq { display: flex; align-items: flex-end; gap: 2.5px; height: 18px; }
        .vts-q-bar { width: 3px; background: ${C.gold}; border-radius: 2px; animation: vts-eqBar 1s ease-in-out infinite; }
        .vts-q-bar:nth-child(2) { animation-delay: .18s; }
        .vts-q-bar:nth-child(3) { animation-delay: .36s; }

        .vts-q-info { flex: 1; min-width: 0; }
        .vts-q-name {
          font-family: 'Playfair Display', serif;
          font-size: 13px; font-weight: 700; color: #fff;
          white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin-bottom: 3px;
        }
        .vts-q-item.active .vts-q-name { color: ${C.goldLight}; }
        .vts-q-event { font-size: 11px; color: rgba(255,255,255,.35); }
        .vts-q-num {
          font-size: 11px; color: rgba(255,255,255,.2); flex-shrink: 0;
          font-family: 'Playfair Display', serif;
        }
        .vts-q-item.active .vts-q-num { color: ${C.gold}; font-weight: 700; }

        .vts-queue-nav {
          padding: 16px 20px;
          border-top: 1px solid rgba(255,255,255,.06);
          display: flex; align-items: center; justify-content: space-between; flex-shrink: 0;
        }
        .vts-nav-label { font-size: 11px; color: rgba(255,255,255,.25); letter-spacing: 1px; text-transform: uppercase; }
        .vts-nav-arrows { display: flex; gap: 8px; }
        .vts-nav-btn {
          width: 38px; height: 38px; border-radius: 50%;
          background: rgba(255,255,255,.05); border: 1px solid rgba(255,255,255,.1);
          color: rgba(255,255,255,.55); font-size: 17px; font-weight: 700;
          display: flex; align-items: center; justify-content: center;
          cursor: pointer; transition: all .25s;
        }
        .vts-nav-btn:hover { background: ${C.gold}; color: ${C.dark}; border-color: ${C.gold}; }

        /* bottom strip */
        .vts-strip {
          padding: 28px clamp(20px,5vw,60px) 56px;
          display: flex; align-items: center; justify-content: space-between;
          gap: 20px; flex-wrap: wrap;
          border-top: 1px solid rgba(255,255,255,.05);
          position: relative; z-index: 2;
        }
        .vts-ratings { display: flex; align-items: center; gap: 28px; flex-wrap: wrap; }
        .vts-r-item { text-align: center; }
        .vts-r-num {
          font-family: 'Playfair Display', serif;
          font-size: 22px; font-weight: 700; color: ${C.gold}; line-height: 1;
        }
        .vts-r-label { font-size: 10px; color: rgba(255,255,255,.28); text-transform: uppercase; letter-spacing: 1px; margin-top: 4px; }
        .vts-r-sep { width: 1px; height: 36px; background: rgba(255,255,255,.06); }

        .vts-btn-gold {
          position: relative; overflow: hidden;
          background: linear-gradient(135deg, #B8860B, ${C.gold}, ${C.goldBright}, ${C.gold}, #9A6E10);
          background-size: 200% 200%; animation: vts-goldBg 3s ease infinite;
          color: ${C.dark}; border: none; border-radius: 50px; padding: 13px 30px;
          font-weight: 800; font-size: 14px; cursor: pointer;
          box-shadow: 0 6px 24px rgba(201,168,76,.4);
          display: inline-flex; align-items: center; gap: 8px;
          font-family: 'DM Sans', sans-serif;
          transition: transform .3s, box-shadow .3s;
          text-decoration: none; flex-shrink: 0;
        }
        .vts-btn-gold::before {
          content: ''; position: absolute; top: 0; left: -100%; width: 55%; height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,.4), transparent);
          animation: vts-shine 3s ease infinite;
        }
        .vts-btn-gold:hover { transform: translateY(-2px); box-shadow: 0 12px 36px rgba(201,168,76,.55); color: ${C.dark}; }

        /* ── responsive ── */
        @media (max-width: 1024px) {
          .vts-stage { grid-template-columns: 1fr 280px; }
        }

        @media (max-width: 768px) {
          .vts-stage { grid-template-columns: 1fr; grid-template-rows: auto auto; }
          .vts-reel-pane { padding: 32px 16px; min-height: auto; }
          .vts-reel { width: 100%; max-width: 100%; aspect-ratio: 16 / 9; }

          /* side arrows — stay left/right of the reel on mobile too */
          .vts-side-arr.prev { left: 4px; }
          .vts-side-arr.next { right: 4px; }
          .vts-side-arr {
            width: 36px; height: 36px; font-size: 18px;
            background: rgba(201,168,76,.2);
            border-color: rgba(201,168,76,.4);
            color: ${C.goldLight};
          }

          .vts-queue {
            border-left: none;
            border-top: 1px solid rgba(255,255,255,.06);
            max-height: none;
          }
          .vts-queue-list {
            display: flex; flex-direction: row;
            overflow-x: auto; overflow-y: hidden;
            padding: 10px 16px 14px; gap: 10px;
            -webkit-overflow-scrolling: touch;
          }
          .vts-queue-list::-webkit-scrollbar { display: none; }
          .vts-q-item {
            flex-direction: column; align-items: center; text-align: center;
            min-width: 84px; border-left: none;
            border-bottom: 3px solid transparent;
            padding: 8px; border-radius: 12px;
          }
          .vts-q-item.active { border-bottom-color: ${C.gold}; border-left-color: transparent; }
          .vts-q-thumb { width: 50px; height: 76px; }
          .vts-q-num { display: none; }
          .vts-strip { flex-direction: column; align-items: flex-start; }
          .vts-r-sep { display: none; }
        }

        @media (max-width: 767px) {
          .vts-reel {
            width: min(82vw, 320px) !important;
            aspect-ratio: 9 / 14 !important;
            border-radius: 24px !important;
            border: 1px solid rgba(201,168,76,.3) !important;
          }
          .vts-video {
            object-fit: cover !important;
          }
        }

        @media (max-width: 480px) {
          .vts-h { font-size: clamp(24px, 7vw, 32px); }
          .vts-reel-pane { padding: 24px 12px; }
          .vts-side-arr { width: 32px; height: 32px; font-size: 16px; }
          .vts-side-arr.prev { left: 2px; }
          .vts-side-arr.next { right: 2px; }
        }
      `}</style>

      <Header />
      <section className="vts-sec" id="video-testimonials" ref={sectionRef}>

        {/* Header */}
        <div className="vts-header">
          <div>
            <div className="vts-eyebrow">
              <div className="vts-eyebrow-line" />
              Customer Stories
              <div className="vts-eyebrow-line" />
            </div>
            <h2 className="vts-h">
              Real People,<br /><em>Real Celebrations</em>
            </h2>
          </div>
          <div className="vts-counter">
            <span>{String(activeIdx + 1).padStart(2, "0")}</span>
            {" / " + String(TESTIMONIALS.length).padStart(2, "0")}
          </div>
        </div>

        {/* Stage */}
        <div className="vts-stage">
          <div className={`vts-transition${transitioning ? " show" : ""}`} />

          {/* Reel Pane — arrows sit left/right inside this container */}
          <div className="vts-reel-pane">
            <div className={`vts-glow-sphere${playing ? " playing-glow" : ""}`} />

            {/* ── Prev arrow — floats left of the reel ── */}
            <button className="vts-side-arr prev" onClick={goPrev} aria-label="Previous">‹</button>

            <div
              className={`vts-reel${playing ? " playing" : ""}`}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              onClick={handleReelClick}
            >
              <div className="vts-notch" />

              <div className="vts-prog">
                <div className="vts-prog-fill" style={{ width:`${progress}%` }} />
              </div>

              <video
                key={activeIdx}
                ref={videoRef}
                className="vts-video"
                src={cur.src}
                muted={false}
                playsInline
                preload="auto"
                onLoadedMetadata={(e) => { e.target.currentTime = 0.01; }}
              />

              {/* slim bottom gradient only — so name text stays readable */}
              <div className="vts-ovl" />

              {/* Play button with perfectly concentric pulse */}
              {!playing && (
                <div className="cc-play-button-wrapper">
                  <div className="cc-play-pulse" />
                  <button className="cc-play-btn" onClick={handlePlayBtnClick} aria-label="Play">
                    <svg width="24" height="24" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>
                  </button>
                </div>
              )}

              {/* info — stars + name */}
              <div className="vts-reel-info" key={activeIdx}>
                <div className="vts-stars">
                  {[1,2,3,4,5].map(n => (
                    <span key={n} style={{ fontSize:13, color: n <= cur.rating ? C.gold : "rgba(201,168,76,.2)" }}>★</span>
                  ))}
                </div>
                <div className="vts-identity">
                  <div className="vts-avatar">
                    {cur.name.split(" ").map(w => w[0]).slice(0, 2).join("")}
                  </div>
                  <div>
                    <div className="vts-name">{cur.name}</div>
                  </div>
                </div>
              </div>
            </div>

            {/* ── Next arrow — floats right of the reel ── */}
            <button className="vts-side-arr next" onClick={goNext} aria-label="Next">›</button>
          </div>

          {/* Queue Sidebar */}
          <div className="vts-queue">
            <div className="vts-queue-header">
              <div className="vts-queue-title">Up Next</div>
            </div>
            <div className="vts-queue-list">
              {TESTIMONIALS.map((t, i) => (
                <div
                  key={i}
                  className={`vts-q-item${i === activeIdx ? " active" : ""}`}
                  onClick={() => goTo(i)}
                >
                  <div className="vts-q-thumb">
                    <div className="vts-q-thumb-bg" />
                    <span className="vts-q-initials">
                      {t.name.split(" ").map(w => w[0]).slice(0, 2).join("")}
                    </span>
                    {i === activeIdx && playing && (
                      <div className="vts-q-eq-wrap">
                        <div className="vts-q-eq">
                          <div className="vts-q-bar" />
                          <div className="vts-q-bar" />
                          <div className="vts-q-bar" />
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="vts-q-info">
                    <div className="vts-q-name">{t.name}</div>
                    <div className="vts-q-event">{t.event} · {t.loc}</div>
                  </div>
                  <div className="vts-q-num">{String(i + 1).padStart(2, "0")}</div>
                </div>
              ))}
            </div>
            <div className="vts-queue-nav">
              <span className="vts-nav-label">Navigate</span>
              <div className="vts-nav-arrows">
                <button className="vts-nav-btn" onClick={goPrev} aria-label="Previous">‹</button>
                <button className="vts-nav-btn" onClick={goNext} aria-label="Next">›</button>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom strip */}
        <div className="vts-strip">
          <div className="vts-ratings">
            {[
              { num:"4.9★", label:"Google" },
              null,
              { num:"5★", label:"By Families" },
              null,
              { num:"5★",  label:"Rated By Couples" },
              null,
              { num:"50k+", label:"Happy Customers" },
            ].map((item, i) =>
              item === null
                ? <div key={i} className="vts-r-sep" />
                : <div key={i} className="vts-r-item">
                    <div className="vts-r-num">{item.num}</div>
                    <div className="vts-r-label">{item.label}</div>
                  </div>
            )}
          </div>
          <a href="/locations" className="vts-btn-gold">🎉 Book Your Celebration</a>
        </div>

      </section>
    </>
  );
}